import { User } from '../domain/user'

// Core role definitions
export enum UserRole {
  Admin = 'admin',
  Manager = 'manager',
  Billing = 'billing',
  PurchaseOrderOperator = 'purchaseOrderOperator',
}

export enum OpsUserRole {
  PurchaseOrderOperator = 'purchaseOrderOperator',
  PurchaseOrderImplementationManager = 'purchaseOrderImplementationManager',
}

export type Role = UserRole | OpsUserRole

// Role sets
const managerRoles = [UserRole.Admin, UserRole.Manager] as const
const userRoles = [...new Set([...Object.values(UserRole), ...Object.values(OpsUserRole)])] as const

// Type guard for role checking
export const isValidRole = (role: string): role is Role =>
  [...Object.values(UserRole), ...Object.values(OpsUserRole)].some((validRole) => validRole === role)

export const hasRoles = (user: User, roles: Role[]): boolean => {
  return roles.some((role) => (user.roles || []).includes(role))
}

export const authorize = {
  admins: [UserRole.Admin],
  managers: [...managerRoles],
  managerOrBilling: [...managerRoles, UserRole.Billing],
  purchaseOrderOperators: [OpsUserRole.PurchaseOrderOperator],
  all: userRoles,
}
